export var FeatureRequestResolutions;
(function (FeatureRequestResolutions) {
    FeatureRequestResolutions[FeatureRequestResolutions["COLLECTING_VOTES"] = 110] = "COLLECTING_VOTES";
    FeatureRequestResolutions[FeatureRequestResolutions["PLANNED"] = 111] = "PLANNED";
    FeatureRequestResolutions[FeatureRequestResolutions["IN_DEVELOPMENT"] = 112] = "IN_DEVELOPMENT";
    FeatureRequestResolutions[FeatureRequestResolutions["COMING_SOON"] = 114] = "COMING_SOON";
    FeatureRequestResolutions[FeatureRequestResolutions["RELEASED"] = 116] = "RELEASED";
})(FeatureRequestResolutions || (FeatureRequestResolutions = {}));
export var KnownIssueResolutions;
(function (KnownIssueResolutions) {
    KnownIssueResolutions[KnownIssueResolutions["INVESTIGATING"] = 120] = "INVESTIGATING";
    KnownIssueResolutions[KnownIssueResolutions["WORKING_ON_IT"] = 122] = "WORKING_ON_IT";
    KnownIssueResolutions[KnownIssueResolutions["RESOLVED"] = 124] = "RESOLVED";
    KnownIssueResolutions[KnownIssueResolutions["THIRD_PARTY_BUG"] = 126] = "THIRD_PARTY_BUG";
})(KnownIssueResolutions || (KnownIssueResolutions = {}));
export var ArticleResolution;
(function (ArticleResolution) {
    ArticleResolution[ArticleResolution["COLLECTING_VOTES"] = 110] = "COLLECTING_VOTES";
    ArticleResolution[ArticleResolution["PLANNED"] = 111] = "PLANNED";
    ArticleResolution[ArticleResolution["IN_DEVELOPMENT"] = 112] = "IN_DEVELOPMENT";
    ArticleResolution[ArticleResolution["COMING_SOON"] = 114] = "COMING_SOON";
    ArticleResolution[ArticleResolution["RELEASED"] = 116] = "RELEASED";
    ArticleResolution[ArticleResolution["INVESTIGATING"] = 120] = "INVESTIGATING";
    ArticleResolution[ArticleResolution["WORKING_ON_IT"] = 122] = "WORKING_ON_IT";
    ArticleResolution[ArticleResolution["RESOLVED"] = 124] = "RESOLVED";
    ArticleResolution[ArticleResolution["THIRD_PARTY_BUG"] = 126] = "THIRD_PARTY_BUG";
})(ArticleResolution || (ArticleResolution = {}));
//# sourceMappingURL=article-resolution.enum.js.map